import { render } from "./PageAccount.vue?vue&type=template&id=2d6b15b4"
import script from "./PageAccount.vue?vue&type=script&lang=js"
export * from "./PageAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__